module.exports = __webpack_public_path__ + "img/ci.fdba8221.png";